import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, kinds }) {
  const { actor, loading } = useAuth();
  const location = useLocation();

  if (loading || actor === null) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="animate-pulse text-[var(--sw-ink-soft)]">Loading…</div>
      </div>
    );
  }
  if (!actor) {
    const fallback = location.pathname.startsWith("/play") ? "/student-login" : "/login";
    return <Navigate to={fallback} state={{ from: location }} replace />;
  }
  if (kinds && !kinds.includes(actor.kind)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
